<script setup lang="ts">
import type { VideoProps } from "./video.types";
import { useVideo } from "./useVideo";

defineOptions({ name: "EVideo" });

const props = withDefaults(defineProps<VideoProps>(), {
  lazy: false,
  rounded: true,
  autoplay: false,
  muted: false,
  loop: false,
  controls: false,
  skeleton: undefined,
});

const {
  mediaClasses,
  wrapperClasses,
  videoSrc,
  isAutoplay,
  isMuted,
  isLoop,
  isControls,
  showSkeleton,
  skeletonClasses,
  onLoadedData,
} = useVideo({ props });
</script>

<template>
  <div :class="wrapperClasses" class="e-video">
    <video
      part="base"
      :src="videoSrc"
      :poster="props.poster"
      :width="props.width"
      :height="props.height"
      :autoplay="isAutoplay"
      :muted="isMuted"
      :loop="isLoop"
      :controls="isControls"
      :class="mediaClasses"
      playsinline
      @loadeddata="onLoadedData"
    />
    <div v-if="showSkeleton" part="skeleton" :class="skeletonClasses" role="presentation" aria-hidden="true" />
  </div>
</template>

<style>
:host {
  display: inline-block;
}
</style>
